import React from "react";

const SvgHarms = props => (
  <svg data-name="Layer 1" viewBox="0 0 215 215" {...props}>
    <path
      d="M135.1 40.65a24 24 0 1024 24 24.06 24.06 0 00-24-24zm-31.16 24.04a24 24 0 10-24 24 24.06 24.06 0 0024-24zm-45.08 0a21 21 0 1121 21 21.06 21.06 0 01-21-21zm34.36 106.66H66.58V98.54a38.46 38.46 0 0026.64 0v15.76c1-.68 2-1.34 3-2V94l-2.11.93a35.34 35.34 0 01-28.43 0l-2.1-.93v80.34h32.64v-32.85l-3 1.63z"
      fill="currentColor"
    />
    <path
      d="M135.11 97.92a34.91 34.91 0 01-14.4-3.06l-1.59-.7-.47 1.67c-.73 2.57-4.91 8.81-24.75 21.6-4.43 2.86-9.49 5.93-14.61 8.87a9.19 9.19 0 004.57 17.16 9.23 9.23 0 004.23-1c2.7-1.4 5.1-2.69 7.35-3.94 11.38-6.33 19.23-11.83 23.35-16.38v52.24h32.64V94l-2.11.93a34.73 34.73 0 01-14.21 2.99z"
      fill="currentColor"
    />
  </svg>
);

export default SvgHarms;